import styled from 'styled-components';

export const infoBoxStyle = {
    padding: '12px 16px',
    backgroundColor: '#f8f9fa',
    border: '1px solid #dee2e6',
    borderRadius: '8px',
    fontSize: '13px',
    color: '#495057',
    lineHeight: '1.8',
};

export const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    boxSizing: 'border-box',
    fontFamily: 'Roboto, sans-serif',
};

export const labelStyle = {
    fontSize: '12px',
    color: '#868e96',
    marginBottom: '4px',
    display: 'block',
};